import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const CAMPAIGN_API_URL = "dialer/campaigns/";

export const fetchCampaigns = createAsyncThunk("campaigns/fetchCampaigns", async (params, thunkAPI) => {
    try {
        const state = thunkAPI.getState();
        const token = state.auth.token;
        const user = state.auth.user;
        if (!token) return;

        let apiUrl = CAMPAIGN_API_URL;
        if (user?.is_tc) {
            apiUrl = "dialer/telecaller-campaigns/";
        }

        const response = await axios.get(apiUrl, {
            params: params,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }
        });
        return response?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch campaigns list"
      );
    }
});


// export const fetchAddCampaigns = createAsyncThunk("campaigns/fetchAddCampaigns", async (payload, thunkAPI) => {
//     try {
//         const state = thunkAPI.getState();
//         const token = state.auth.token;
//         if (!token) return;

//         const response = await axios.post('dialer/create-campaigns/', payload, {
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//             }
//         });
//         console.log(response, "====campaign add response====");
        
//         return response?.data;
//     } catch (error) {
//         return thunkAPI.rejectWithValue(
//         error.response?.data?.message ||
//         error.message ||
//         "Failed to create campaign"
//       );
//     }
// });
// export const fetchEditCampaigns = createAsyncThunk("campaigns/fetchEditCampaigns", async ({ id, payload }, thunkAPI) => {
//     try {
//         const state = thunkAPI.getState();
//         const token = state.auth.token;
//         if (!token) return;

//         const response = await axios.patch(`dialer/campaigns/${id}/`, payload, {
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//             }
//         });
//         return response?.data;
//     } catch (error) {
//         return thunkAPI.rejectWithValue(
//             error.response?.data?.message ||
//             error.message ||
//             "Failed to edit campaign"
//         );
//     }
// });

const campaignSlice = createSlice({
  name: "campaign",
  initialState: {
    campaigns_list: [],
    campaign_list_loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(fetchCampaigns.pending, (state) => {
      state.campaign_list_loading = true;
      state.error = null;
    })
    .addCase(fetchCampaigns.fulfilled, (state, action) => {
      state.campaign_list_loading = false;
      state.campaigns_list = action.payload;
    })
    .addCase(fetchCampaigns.rejected, (state, action) => {
      state.campaign_list_loading = false;
      state.error = action.payload || "Something went wrong";
      state.campaigns_list = [];
    });
  },
});

export default campaignSlice.reducer;